
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/top/products/[id]",
      function () {
        return require("private-next-pages/top/products/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/top/products/[id]"])
      });
    }
  